export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand-lockup" aria-label="GOP ALA">
      <span className="brand-mark" aria-hidden="true">
        <img src="/brand/gop-ala.webp" alt="" />
      </span>
      {!compact && (
        <span className="brand-copy">
          <strong>GOP ALA</strong>
          <small>ECUADOR</small>
        </span>
      )}
    </div>
  );
}
